<template>
  <v-app class="app">
    <Header v-if="!isLogin">
      <div class="logo">
        <router-link to="/" class="logo__icon" exact>Trans Tech</router-link>
      </div>

      <div class="tabs">
        <div :class="[ 'tabs__orders', isActive('/orders') ? 'active' : '' ]">
          <router-link to="/orders" exact>
            <p>Orders</p>
          </router-link>
        </div>
        <div :class="[ 'tabs__orders', isActive('/batches') ? 'active' : '' ]">
          <router-link to="/batches/today" exact>
            <p>Batches</p>
          </router-link>
        </div>
        <div v-if="user.admin" :class="[ 'tabs__admin', isActive('/users') ? 'active' : '' ]">
          <router-link to="/users" exact>
            <p>Admin</p>
          </router-link>
        </div>
      </div>

      <div>
        <v-menu class="dropdown" open-on-hover bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn class="ma-2" text v-on="on">
              <router-link v-if="!loggedIn" to="/login" exact>Log In</router-link>
              <span v-if="loggedIn">
                <span class="dropdown__user-name">
                  {{ user.name }}
                  <v-icon class="dropdown__arrow-icon" right>mdi-menu-down</v-icon>
                </span>
              </span>
            </v-btn>
          </template>

          <v-list v-if="loggedIn">
            <v-list-item @click="openPasswordModal()">
              <v-list-item-title>CHANGE PASSWORD</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-title>SIGN OUT</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </Header>

    <v-content>
      <router-view v-on:login="getUser" />
    </v-content>
    <PasswordModal v-if="isOpen" v-on:close="closePasswordModal" />
  </v-app>
</template>

<script>
import API from './services/API';
import Header from './components/Header.vue';
import PasswordModal from './components/PasswordModal';

export default {
  name: 'App',
  components: { Header, PasswordModal },
  data() {
    return {
      drawer: false,
      loggedIn: false,
      isOpen: false,
      user: {},
      notificationCount: 0,
      notifications: [
        {
          title: 'No Notifications',
          text: '',
          icon: 'insert_emoticon',
        },
      ],
    };
  },
  computed: {
    isLogin() {
      return (
        this.$route.path === '/login' || this.$route.path === '/resetpassword'
      );
    },
  },
  methods: {
    logout() {
      API.get('/auth/logout')
          .then((_res) => {
            this.user = {};
            this.loggedIn = false;
            this.$router.push({ path: '/login' });
          })
          .catch((err) => {
            console.error(err);
          });
    },
    isActive(route) {
      return this.$route.path.includes(route);
    },
    openPasswordModal() {
      this.isOpen = true;
    },
    closePasswordModal() {
      this.isOpen = false;
    },
    getUser() {
      API.get(`/users/me`)
          .then((res) => {
            this.loggedIn = true;
            this.user = res.data;
          })
          .catch((_err) => {
            this.loggedIn = false;
          });
    },
  },
  mounted() {
    if (this.$route.path !== '/resetpassword') {
      this.getUser();
    }
  },
};
</script>

<style lang="scss">
@import "./main.scss";

.app {
  overflow-x: auto;
  overflow-y: hidden;
}

.logo {
  display: flex;
  justify-content: center;
  padding-right: 3rem;

  &__icon {
    display: block;
    text-indent: -9999px;
    width: 14rem;
    height: 3.4rem;
    background: url("../src/assets/img/Logo.svg");
    background-size: 14rem 3.4rem;
  }
}

.tabs {
  width: 22rem;
  display: flex;
  color: #a9a9a9;
  display: flex;
  justify-content: space-between;

  .active {
    border-bottom: #ffd03b 0.8rem solid;
    color: #fff !important;
  }

  & > div {
    width: 10rem;
    height: 8rem;
    margin-bottom: 1.2rem;
    border-bottom: transparent 0.8rem solid;

    display: flex;

    &:hover {
      color: #fff;
    }

    a {
      display: flex;
      width: 100%;
      height: 100%;
      color: inherit;
      text-decoration: none;

      justify-content: center;
      align-items: center;

      p {
        margin-top: 2.5rem;
        height: 2.7rem;
        width: 12.3rem;
        font-family: Heebo;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 27px;
        text-align: center;
      }
    }

    &:not(:first-child) {
      margin-left: 20px;
    }
  }
}

.dropdown {
  &__user-name {
    height: 2.7rem;
    color: #ffffff;
    font-family: Heebo;
    font-size: 1.8rem;
    line-height: 2.7rem;
    text-align: right;
  }

  &__arrow-icon {
    color: grey !important;
  }
}
</style>

